'use client';

import styles from './FinanceDetails.module.css';
import { Typography } from '@gds/Typography/Typography';

type Strings = {
  title: string;
  description: string;
  totalDeposit: string;
  month: string;
  totalMileage: string;
  totalDuration: string;
  fixedApr: string;
  orderOnline?: string;
};

export function FinanceDetails({
  strings,
  values,
  children,
}: {
  strings: Strings;
  values: {
    deposit: string;
    monthlyPrice: string;
    months: number;
    mileage?: number;
    apr?: string;
  };
  children?: React.ReactNode;
}) {
  const { deposit, monthlyPrice, months, mileage } = values;

  return (
    <div className={styles.content}>
      <div className={styles.contentInner}>
        <div>
          <Typography variant={'h5'} Component="p" className={styles.pricePerMonth}>
            {monthlyPrice}/{strings.month}
          </Typography>
          <ul className={styles.breakdown}>
            <Typography variant={'body4'} Component={'li'}>
              {strings.totalDeposit}: <strong>{deposit}</strong>
            </Typography>
            <Typography variant={'body4'} Component={'li'}>
              {strings.totalDuration}:{' '}
              <strong>
                {months} {strings.month}
              </strong>
            </Typography>
            {Boolean(values.mileage) && (
              <Typography variant={'body4'} Component={'li'}>
                {strings.totalMileage}: <strong>{mileage}km</strong>
              </Typography>
            )}
            {values.apr && (
              <Typography variant={'body4'} Component={'li'}>
                {strings.fixedApr}: <strong>{values.apr}</strong>
              </Typography>
            )}
          </ul>
        </div>
        {children}
      </div>
    </div>
  );
}
